<template>
  <div class="publicMain">
    <el-row>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>{{ $t('userInfo.cardHeadTil') }}</span>
          </div>
          <div>
            <el-row class="rowImgClass">
              <el-col :span="6" style="display: flex; align-items: center; justify-content: center;">
                <img v-bind:src="imgOptions.img" @click="editCropper()" :title="$t('userInfo.imgClickTil')" class="img-circle img-lg" />
                <el-dialog :title="imgTitle" :visible.sync="dialogFormVisible" width="800px" append-to-body @opened="modalOpened">
                  <el-row>
                    <el-col :xs="24" :md="12" :style="{height: '350px'}">
                      <vue-cropper
                        ref="cropper"
                        :img="imgOptions.img"
                        :info="true"
                        :autoCrop="imgOptions.autoCrop"
                        :autoCropWidth="imgOptions.autoCropWidth"
                        :autoCropHeight="imgOptions.autoCropHeight"
                        :fixedBox="imgOptions.fixedBox"
                        @realTime="realTime"
                        v-if="cropperVisible"
                      />
                    </el-col>
                    <el-col :xs="24" :md="12" :style="{height: '350px'}">
                      <div class="avatar-upload-preview">
                        <img :src="previews.url" :style="previews.img" />
                      </div>
                    </el-col>
                  </el-row>
                  <br />
                  <el-row>
                    <el-col :lg="2" :md="2">
                      <el-upload action="#" :http-request="requestUpload" :show-file-list="false" :before-upload="beforeUpload">
                        <el-button size="small">
                          <span>{{ $t('userInfo.imgUpdate') }}</span>
                          <i class="el-icon-upload el-icon--right"></i>
                        </el-button>
                      </el-upload>
                    </el-col>
                    <el-col :lg="{span: 1, offset: 2}" :md="2">
                      <el-button icon="el-icon-plus" size="small" @click="changeScale(1)"></el-button>
                    </el-col>
                    <el-col :lg="{span: 1, offset: 1}" :md="2">
                      <el-button icon="el-icon-minus" size="small" @click="changeScale(-1)"></el-button>
                    </el-col>
                    <el-col :lg="{span: 1, offset: 1}" :md="2">
                      <el-button icon="el-icon-refresh-left" size="small" @click="rotateLeft()"></el-button>
                    </el-col>
                    <el-col :lg="{span: 1, offset: 1}" :md="2">
                      <el-button icon="el-icon-refresh-right" size="small" @click="rotateRight()"></el-button>
                    </el-col>
                    <el-col :lg="{span: 2, offset: 6}" :md="2">
                      <el-button type="primary" size="small" @click="uploadImg()">{{ $t('common.submitBtn') }}</el-button>
                    </el-col>
                  </el-row>
                </el-dialog>
              </el-col>
              <el-col :span="18">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                  <el-tab-pane :label="$t('userInfo.tabsHeadTil')" name="first">
                    <el-form v-show="editFlg" ref="userInfoForm" :model="userInfoForm" size="small" :label-width=labelWidth>
                      <el-row class="formItemClass">
                        <el-col :span="8">
                          <el-form-item :label="$t('userInfo.userName')">
                            <span>：{{ userInfoForm.suid ? userInfoForm.suid : '' }}</span>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8" :offset="1">
                          <el-form-item :label="$t('userInfo.nickName')">
                            <span>：{{ userInfoForm.uname ? userInfoForm.uname : '' }}</span>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row class="formItemClass">
                        <el-col :span="8">
                          <el-form-item :label="$t('userInfo.cardId')">
                            <span>：{{ userInfoForm.sfzh ? userInfoForm.sfzh : '' }}</span>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8" :offset="1">
                          <el-form-item :label="$t('userInfo.telNo')">
                            <span>：{{ userInfoForm.tel ? userInfoForm.tel : '' }}</span>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row class="formItemClass">
                        <el-col :span="8">
                          <el-form-item :label="$t('userInfo.email')">
                            <span>：{{ userInfoForm.email ? userInfoForm.email : '' }}</span>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8" :offset="1">
                          <el-form-item :label="$t('userInfo.roleName')">
                            <span>：{{ userInfoForm.jsname ? userInfoForm.jsname : '' }}</span>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row class="formItemClass">
                        <el-col :span="8">
                          <el-form-item :label="$t('userInfo.userStat')">
                            <span>：{{ userInfoForm.isok == '1' ? $t('userInfo.selectOn') : $t('common.selectOff') }}</span>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8" :offset="1">
                          <el-form-item :label="$t('userInfo.islocalUser')">
                            <span>：{{ userInfoForm.isweb == '1' ? $t('common.yes') : $t('common.no') }}</span>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-form-item>
                        <el-row>
                          <el-button type="primary" size="mini" @click="submit('userInfoForm', 'edit')">{{ $t('common.editBtn') }}</el-button>
                        </el-row>
                      </el-form-item>
                    </el-form>
                    <el-form v-show="!editFlg" ref="userForm" :model="userForm" :rules="userInfoRules" size="small" :label-width=labelWidth>
                      <el-row>
                        <el-col :span="8">
                          <el-form-item :label="$t('userInfo.userName')">
                            <span>{{ userForm.suid ? userForm.suid : '' }}</span>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8" :offset="1">
                          <el-form-item :label="$t('userInfo.nickName')" prop="uname">
                            <el-input v-model="userForm.uname" />
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="8">
                          <el-form-item :label="$t('userInfo.cardId')" prop="sfzh">
                            <el-input v-model="userForm.sfzh" maxlength="18" />
                          </el-form-item>
                        </el-col>
                        <el-col :span="8" :offset="1">
                          <el-form-item :label="$t('userInfo.telNo')" prop="tel">
                            <el-input v-model="userForm.tel" maxlength="11" />
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="8">
                          <el-form-item :label="$t('userInfo.email')" prop="email">
                            <el-input v-model="userForm.email" maxlength="50" />
                          </el-form-item>
                        </el-col>
                        <el-col :span="8" :offset="1">
                          <el-form-item :label="$t('userInfo.roleName')" prop="jsname">
                            <el-input v-model="userForm.jsname" maxlength="50" disabled />
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="8">
                          <el-form-item :label="$t('userInfo.userStat')" prop="isok">
                            <el-switch class="isOkClass"
                              disabled
                              v-model="userForm.isok"
                              active-value="1"
                              inactive-value="0"
                              :active-text="$t('userInfo.selectOn')"
                              :inactive-text="$t('common.selectOff')">
                            </el-switch>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8" :offset="1">
                          <el-form-item :label="$t('userInfo.islocalUser')" prop="isweb">
                            <el-switch class="isWebClass"
                              disabled
                              v-model="userForm.isweb"
                              active-value="1"
                              inactive-value="0"
                              :active-text="$t('common.yes')"
                              :inactive-text="$t('common.no')">
                            </el-switch>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-form-item>
                        <el-row>
                          <el-button type="primary" size="mini" @click="submit('userForm', 'infoEdit')">{{ $t('common.saveBtn') }}</el-button>
                          <el-button size="mini" @click="submit('userForm', 'cancel')">{{ $t('common.cancelBtn') }}</el-button>
                        </el-row>
                      </el-form-item>
                    </el-form>
                  </el-tab-pane>
                  <el-tab-pane :label="$t('userInfo.editPwd')" name="second">
                    <el-form ref="pwdForm" :model="pwdForm" :rules="pwdRules" size="small" :label-width="$i18n.locale == 'zh' ? '80px' : '130px'">
                      <el-form-item :label="$t('userInfo.oldPwd')" prop="oldPassword">
                        <el-input v-model="pwdForm.oldPassword" :placeholder="$t('userInfo.ruleMsg') + $t('userInfo.oldPwd')" style="width: 30%" type="password" show-password />
                      </el-form-item>
                      <el-form-item :label="$t('userInfo.newPwd')" prop="newPassword">
                        <el-input v-model="pwdForm.newPassword" :placeholder="$t('userInfo.ruleMsg') + $t('userInfo.newPwd')" style="width: 30%" type="password" show-password />
                      </el-form-item>
                      <el-form-item :label="$t('userInfo.confirmPwd')" prop="confirmPassword">
                        <el-input v-model="pwdForm.confirmPassword" :placeholder="$t('userInfo.ruleMsg2') + $t('userInfo.confirmPwd')" style="width: 30%" type="password" show-password />
                      </el-form-item>
                      <el-form-item>
                        <el-button type="primary" size="mini" @click="submit('pwdForm', 'pwdEdit')">{{ $t('common.saveBtn') }}</el-button>
                      </el-form-item>
                    </el-form>
                  </el-tab-pane>
                </el-tabs>
              </el-col>
            </el-row>
          </div>
        </el-card>
    </el-row>
  </div>
</template>

<script>

export default {
  name: 'grzl',
  computed: {
    labelWidth() {
      return this.$i18n.locale == 'zh' ? '80px' : '100px';
    },
    // 弹出层标题
    imgTitle() {
      return this.$t('userInfo.imgTil')
    },
    userInfoRules() {    // 模态框数据校验规则
      return {
        uname: [
          { required: true, message: this.$t('userInfo.roleNameMsg'), trigger: "blur" }
        ],
        sfzh: [
          { required: true, message: this.$t('userInfo.roleCardMsg'), trigger: "blur" }
        ],
        tel: [
          { required: true, message: this.$t('userInfo.roleTelMsg'), trigger: "blur" },
          { pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/, message: this.$t('userInfo.roleTelOkMsg'), trigger: "blur" }
        ],
        email: [
          { required: true, message: this.$t('userInfo.roleEmailMsg'), trigger: "blur" },
          { type: "email", message: this.$t('userInfo.roleEmailOkMsg'), trigger: "blur" }
        ],
        jsname: [
          { required: true, message: this.$t('userInfo.roleJsNameMsg'), trigger: "blur" },
        ],
        isok: [
          { required: true, message: this.$t('userInfo.roleIsOkMsg'), trigger: "blur" },
        ],
        isweb: [
          { required: true, message: this.$t('userInfo.roleIsWebMsg'), trigger: "blur" },
        ],
      }
    },
    pwdRules() {    // 模态框数据校验规则
      return {
        oldPassword: [
          { required: true, message: this.$t('userInfo.roleOldPwdMsg'), trigger: "blur" },
          { required: true, validator: this.pwdCheck, trigger: "blur" }
        ],
        newPassword: [
          { required: true, message: this.$t('userInfo.roleNewPwdMsg'), trigger: "blur" },
          { min: 6, max: 20, message: this.$t('userInfo.roleNewPwdLenMsg'), trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, message: this.$t('userInfo.roleConfirmPwdMsg'), trigger: "blur" },
          { required: true, validator: this.equalToPassword, trigger: "blur" }
        ]
      }
    },
  },
  data() {
    return {
      activeName: 'first',
      userInfoForm: {
        suid: '',
        uname: '',
        sfzh: '',
        tel: '',
        email: '',
        jsname: '',
        isok: '',
        isweb: '',
      },
      userForm: {
        suid: '',
        uname: '',
        sfzh: '',
        tel: '',
        email: '',
        jsname: '',
        isok: '',
        isweb: '',
      },
      pwdForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
      },
      editFlg: true,
      imgOptions: {
        img: "/img/profile.png", // 裁剪图片的地址
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 200, // 默认生成截图框宽度
        autoCropHeight: 200, // 默认生成截图框高度
        fixedBox: true // 固定截图框大小 不允许改变
      },
      // 是否显示弹出层
      dialogFormVisible: false,
      // 是否显示cropper
      cropperVisible: false,
      previews: {}
    };
  },
  methods: {
    /** 向左旋转 */
    rotateLeft() {
      this.$refs.cropper.rotateLeft();
    },
    /** 向右旋转 */
    rotateRight() {
      this.$refs.cropper.rotateRight();
    },
    /** 图片缩放 */
    changeScale(num) {
      num = num || 1;
      this.$refs.cropper.changeScale(num);
    },
    /** 上传预处理 */
    beforeUpload(file) {
      if (file.type.indexOf("image/") == -1) {
        this.$message.error(this.$t('userInfo.imgCheckMsg'));
      } else {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.imgOptions.img = reader.result;
        };
      }
    },
    /** 覆盖默认的上传行为 */
    requestUpload() {},
    /** 实时预览 */
    realTime(data) {
      this.previews = data;
    },
    /** 编辑头像 */
    editCropper() {
      this.dialogFormVisible = true;
    },
    /** 打开弹出层结束时的回调 */
    modalOpened() {
      this.cropperVisible = true;
    },
    pwdCheck(rule, value, callback) {
      let _this = this;
      let queryForm = { suid: _this.$store.state.userInfo.suid, upw: value };
      _this.$ajax.post("/api/pwdCheck", queryForm).then((res) => {
        if(res.data.code == '200') {
          if(res.data.data == '1') {
            callback();
          } else {
            callback(new Error(this.$t('userInfo.roleOldPwdOkMsg')));
          }
        }
      })
    },
    equalToPassword(rule, value, callback) {
      if (this.pwdForm.newPassword !== value) {
        callback(new Error(this.$t('userInfo.roleEqualPwdMsg')));
      } else {
        callback();
      }
    },
    handleClick(tab, event) {
      if(tab.paneName == 'second') {
        this.$refs['pwdForm'].resetFields();
      }
    },
    getUserInfo() {
      let _this = this;
      let queryForm = { suid: _this.$store.state.userInfo.suid };
      _this.$ajax.post("/api/searchUser", queryForm).then((res) => {
        if(res.data.code == '200') {
          $.extend(true, _this.userForm, res.data.data[0]);
          $.extend(true, _this.userInfoForm, res.data.data[0]);
        }
      })
    },
    submit(formName, flg) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(flg == 'edit') {
            this.$refs['userForm'].resetFields();
            $.extend(true, this.userForm, this.userInfoForm);
            this.editFlg = false;
          } else if(flg == 'infoEdit') {
            this.saveUserInfo();
          } else if(flg == 'pwdEdit') {
            this.saveUserPwd();
          } else if(flg == 'cancel') {
            this.editFlg = true;
          }
        } else {
          if(flg == 'cancel') {
            this.editFlg = true;
          }
          console.log('error submit!!');
          return false;
        }
      });
    },
    saveUserInfo() {
      let _this = this;
      _this.$ajax.post('/api/updateUser', _this.userForm).then((res) => {
        if(res.data.code == '200') {
          _this.editFlg = true;
          _this.getUserInfo();
          _this.$message.success(_this.$t('userInfo.editSuccess'));
        }
      });
    },
    saveUserPwd() {
      let _this = this;
      let obj = { suid: _this.$store.state.userInfo.suid, upw: _this.pwdForm.newPassword };
      _this.$ajax.post('/api/updatePwd', obj).then((res) => {
        if(res.status == '200') {
          if(res.data.code == '200') {
            _this.$requestUtil.logout();
            _this.$message.success(_this.$t('userInfo.pwdSuccess'));
          }
        }
      });
    }
  },
  mounted() {
    this.getUserInfo();
  },
};
</script>

<style lang="scss" scoped>
.avatar-upload-preview {
	position: absolute;
	top: 50%;
	transform: translate(50%, -50%);
	width: 180px;
	height: 180px;
	border-radius: 50%;
	box-shadow: 0 0 4px #ccc;
	overflow: hidden;
}
.rowImgClass {
  display: flex;
  // align-items: center;
  height: 300px;
}
.img-circle {
  border-radius: 50%;
}
::v-deep .el-card__header {
  padding: 14px 15px 7px;
  min-height: 40px;
}
::v-deep .el-card__body {
  padding-top: 10px;
}
.box-card {
  text-align: left;
}
.svg-icon {
  width: 1em;
  height: 1em;
}
.userInfo {
  border-bottom: 1px solid #e7eaec;
  // border-top: 1px solid #e7eaec;
  // margin-bottom: -1px;
  padding: 10px 0;
  font-size: 13px;
}

::v-deep .formItemClass {
  label {
    padding: 0;
  }
}
::v-deep .isOkClass {
  .el-switch__label--left {
    position: relative;
    left: 52px;
    margin-right: 0;
    color: #fff;
    z-index: -1111;
  }
  .el-switch__core{
    width: 70px !important;
  }
  .el-switch__label--right {
    position: relative;
    right: 52px;
    margin-left: 0;
    color: #fff;
    z-index: -1111;
  }
  .el-switch__label--right.is-active {
    z-index: 1111;
    color: #fff !important;
  }
  .el-switch__label--left.is-active {
    z-index: 1111;
    color: #9c9c9c !important;
  }
}
/* switch按钮样式 */
::v-deep .isWebClass {
  .el-switch__label--left {
    position: relative;
    left: 37px;
    margin-right: 0;
    color: #fff;
    z-index: -1111;
  }
  .el-switch__core{
    width: 50px !important;
  }
  .el-switch__label--right {
    position: relative;
    right: 37px;
    margin-left: 0;
    color: #fff;
    z-index: -1111;
  }
  .el-switch__label--right.is-active {
    z-index: 1111;
    color: #fff !important;
  }
  .el-switch__label--left.is-active {
    z-index: 1111;
    color: #9c9c9c !important;
  }
}
</style>
